import { cn } from '../../lib/cn.js';
import { Skeleton } from '../ui/Skeleton.js';

interface KpiCardProps {
  label: string;
  value: number | string;
  subLabel?: string;
  isLoading?: boolean;
  className?: string;
}

export function KpiCard({ label, value, subLabel, isLoading, className }: KpiCardProps) {
  return (
    <div className={cn('bg-white border border-border rounded-xl p-4 animate-fade-in', className)}>
      <p className="text-xs text-secondary uppercase tracking-wide font-medium">{label}</p>
      {isLoading ? (
        <Skeleton className="h-8 w-16 mt-2" />
      ) : (
        <p className="text-3xl font-bold text-primary-text mt-1 animate-count-up">{value}</p>
      )}
      {subLabel && <p className="text-xs text-secondary mt-1">{subLabel}</p>}
    </div>
  );
}
